import { activateProfile } from 'features/profile/editProfileSlice'
import ProfileBadge from 'features/profile/ProfileBadge'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import routes from 'routes'
import { activateUser } from '../authSlice'

const ActivationUser = () => {
    const dispatch = useDispatch()
    const { activationKey } = useParams<{ activationKey: string }>()
    const history = useHistory()
    const searchParams = new URLSearchParams(window.location.search).get('organization')
    const goToOrganizationPage = () => (
        history.push(routes.organization.getPath({ organizationId: searchParams }))
    )

    useEffect(() => {
        if (activationKey) {
            dispatch(activateUser({ activationKey }))
            dispatch(activateProfile())
        }
    }, [activationKey, dispatch])

    return (
        <ProfileBadge callback={searchParams && goToOrganizationPage} />
    )
}

export default ActivationUser
